import { useEffect, useState } from 'react';
import { useStore } from '../context/StoreContext';
import service from '../services/customorders.service';

export function useCustomOrders() {
    const { activeStoreId } = useStore();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        service.listenToOrders((data) => {
            setOrders(data);
            setLoading(false);
        });
        return () => service.stopListening();
    }, [activeStoreId]);

    return { orders, loading, activeStoreId };
}
